"use client";

import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      toastOptions={{
        className:
          "!bg-panel !border-line !text-fg !text-sm !shadow-lg",
        descriptionClassName: "!text-fg-dim",
      }}
    />
  );
}
